import { Component, OnInit } from '@angular/core';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerPreOrderList',
  templateUrl: './LetterRequestCustomerPreOrderList.component.html',
  styleUrls: ['./LetterRequestCustomerPreOrderList.component.scss']
})
export class LetterRequestCustomerPreOrderListComponent implements OnInit {
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:String=''
  EndSearchDate:String=''
  CustomerName:String=''

  BaseUrl = environment.BaseUrl + "Fish/LetterPreOrder?id="

  constructor(
    private login_Service: LoginService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {

    this.BaseUrl=environment.BaseUrl + "Fish/LetterPreOrder?id="

    this.Nav_Service.CheckValidPage(1115).subscribe(
      data=>{
        this.login_Service.GetUserRole().subscribe(
          data2=>{
            this.CustomerName=data2['customerName']
          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  GetLetterRequestCustomerPreOrder(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerPreOrder(
      StartSearchDate,
      EndSearchDate).subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data

        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


}
